/**
 * Click-to-copy for the footer email and phone number.
 *
 * Delegated on document so it survives section re-renders and works for any
 * [data-ww-copy] element added later. On success the element briefly swaps its
 * own text for its data-copied-label, then restores it — no toast, no outline,
 * no layout shift beyond the label itself.
 */
(function () {
  if (window.__wwCopyToClipboardReady) return;
  window.__wwCopyToClipboardReady = true;

  const RESTORE_AFTER = 1600;

  /**
   * navigator.clipboard needs a secure context and can still be blocked by
   * permissions policy, so fall back to a hidden textarea + execCommand.
   * @param {string} text
   * @returns {Promise<boolean>}
   */
  const copy = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (err) {
        /* fall through to the legacy path */
      }
    }

    const helper = document.createElement('textarea');
    helper.value = text;
    helper.setAttribute('readonly', '');
    helper.setAttribute('aria-hidden', 'true');
    helper.style.position = 'fixed';
    helper.style.top = '0';
    helper.style.left = '-9999px';
    document.body.appendChild(helper);

    try {
      helper.select();
      return document.execCommand('copy');
    } catch (err) {
      return false;
    } finally {
      helper.remove();
    }
  };

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target ? target.closest('[data-ww-copy]') : null;
    if (!trigger) return;

    event.preventDefault();

    const value = trigger.dataset.wwCopy;
    if (!value || trigger.dataset.copied) return;

    if (!(await copy(value))) return;

    const original = trigger.textContent;
    const label = trigger.dataset.copiedLabel;

    trigger.dataset.copied = 'true';
    if (label) trigger.textContent = label;

    window.setTimeout(() => {
      if (label) trigger.textContent = original;
      delete trigger.dataset.copied;
    }, RESTORE_AFTER);
  });
})();
